import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const CoaPage = lazy(() => import('src/pages/coa/list'));
const CoaEditPage = lazy(() => import('src/pages/coa/edit'));

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  </DashboardLayout>
);

export const coaRoutes = [
  {
    path: 'coa',
    element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
    children: [
      { element: <CoaPage />, index: true },
      { path: 'list', element: <CoaPage /> },
      { path: ':id/edit', element: <CoaEditPage /> },
    ],
  },
];
